function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "19"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-2 0h18v18H-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillOpacity: ".54",
  fillRule: "nonzero",
  d: "M12.6 11.55h1.8c0 3.978-3.222 7.2-7.2 7.2S0 15.528 0 11.55s3.222-7.2 7.2-7.2V.75l4.5 4.5-4.5 4.5v-3.6a5.404 5.404 0 00-5.4 5.4c0 2.979 2.421 5.4 5.4 5.4 2.979 0 5.4-2.421 5.4-5.4zm-6.426 2.646h-.765v-2.934l-.909.279v-.621l1.593-.567h.081v3.843zm1.251-2.25c0-1.719 1.17-1.638 1.296-1.638.117 0 1.296-.072 1.296 1.638v.666c0 1.719-1.17 1.638-1.296 1.638-.117 0-1.296.072-1.296-1.638v-.666zm1.836-.108c0-.675-.198-.918-.54-.909-.333 0-.531.234-.531.909v.873c0 .693.198.927.54.927s.531-.234.531-.927v-.873z"
}))));